(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5750],{

/***/ 68902:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p2p/create-offer",
      function () {
        return __webpack_require__(72987);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H$": function() { return /* binding */ WrappedTokensFlowContext; },
/* harmony export */   "hf": function() { return /* binding */ WrapperTokensFlowProvider; }
/* harmony export */ });
/* unused harmony export initValue */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68203);
/* harmony import */ var _hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74733);




const initValue = {
    selectedToken: null,
    setSelectedToken: ()=>null,
    prevTokenBalance: 0,
    tokenOptions: []
};
const WrappedTokensFlowContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initValue);
const WrapperTokensFlowProvider = (param)=>{
    let { children  } = param;
    const { balances  } = (0,_hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__/* .useBalances */ .l)();
    const [selectedToken, setSelectedToken] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { tokenOptions  } = (0,_hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const prevTokenBalance = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!selectedToken) return 0;
        return balances[selectedToken.symbol] || 0;
    // store the previous balance based on the selectedToken, no need update when the balances are changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedToken
    ]);
    const ctxValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            selectedToken,
            setSelectedToken,
            prevTokenBalance,
            tokenOptions
        }), [
        selectedToken,
        prevTokenBalance,
        tokenOptions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedTokensFlowContext.Provider, {
        value: ctxValue,
        children: children
    });
};


/***/ }),

/***/ 24537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SellProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _providers_payment_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67992);



const initContextState = {
    fiatToken: undefined,
    setFiatToken: ()=>null,
    isOpenRenecInsufficientWarning: false,
    setIsOpenRenecInsufficientWarning: ()=>false
};
const SellContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initContextState);
const SellProvider = (param)=>{
    let { children  } = param;
    const [fiatToken, setFiatToken] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [isOpenRenecInsufficientWarning, setIsOpenRenecInsufficientWarning] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            fiatToken,
            setFiatToken,
            isOpenRenecInsufficientWarning,
            setIsOpenRenecInsufficientWarning
        };
    }, [
        fiatToken,
        setFiatToken,
        isOpenRenecInsufficientWarning,
        setIsOpenRenecInsufficientWarning
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SellContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_payment_info__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            fixedFiatToken: fiatToken,
            children: children
        })
    });
};
SellContext.displayName = "SellContext";
/* harmony default export */ __webpack_exports__["Z"] = (SellContext);


/***/ }),

/***/ 74733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ BLACK_LIST_TOKENS_SYMBOLS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67013);
/* harmony import */ var _utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35108);



const BLACK_LIST_TOKENS_SYMBOLS = [
    "reSOL",
    "reBNB"
];
/**
 * These token options will be used in the deposit and withdraw dialog in the assets page
 */ const useDepositTokenOptions = ()=>{
    const { data: coreTokens = [] , isLoading: isFetchingCoreTokens  } = (0,_hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__/* .useFetchTopCoinList */ .PE)();
    const tokenOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>coreTokens.filter((token)=>!BLACK_LIST_TOKENS_SYMBOLS.includes(token.token_symbol)).map((token)=>(0,_utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__/* .toRegistryTokenInfo */ .ZO)(token)), [
        coreTokens
    ]);
    return {
        tokenOptions,
        isLoading: isFetchingCoreTokens
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDepositTokenOptions);


/***/ }),

/***/ 57836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _MainLayout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _MainLayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72026);



/***/ }),

/***/ 72987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96661);
/* harmony import */ var _components_sell_form_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24537);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1880);
/* harmony import */ var _root_src_layouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57836);






const P2PCreateOfferForm = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3434), __webpack_require__.e(7333), __webpack_require__.e(2054), __webpack_require__.e(2763), __webpack_require__.e(2963), __webpack_require__.e(3724), __webpack_require__.e(4907), __webpack_require__.e(7161), __webpack_require__.e(1466)]).then(__webpack_require__.bind(__webpack_require__, 51466)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(51466)
            ]
    },
    ssr: false
});
const P2PMarketCreateOffer = ()=>{
    const isInstantWire = (0,_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .isInstantWireMode */ .Zo)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_root_src_layouts__WEBPACK_IMPORTED_MODULE_5__/* .MainLayout */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sell_form_context__WEBPACK_IMPORTED_MODULE_3__/* .SellProvider */ .J, {
            children: isInstantWire ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(P2PCreateOfferForm, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_2__/* .WrapperTokensFlowProvider */ .hf, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(P2PCreateOfferForm, {})
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (P2PMarketCreateOffer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,4430,9774,2888,179], function() { return __webpack_exec__(68902); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);